import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { useEngagementContext } from 'modules/engagement/hooks/useEngagementContext'
import { launchSurveys as canLaunchSurveys } from 'modules/engagement/lib/authorization'
import { useEngagementInsightsData } from 'modules/engagement_insights/hooks/useEngagementInsightsData'
import { SelectedSurvey } from 'modules/engagement_insights/lib/widget'

const InsightsBanner = () => {
  const { moduleAvailabilities, canManageSurveys } = useEngagementContext()
  const canLaunchSurveysValue = canLaunchSurveys(moduleAvailabilities, canManageSurveys)
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { climate, enps, setSurveyToBeLaunched } = useEngagementInsightsData()

  const getBannerData = () => {
    if (climate?.isFinished && enps?.isFinished) {
      return {
        manager: i18n.t('engagement_insights.insights_banner.manager.surveys_not_active'),
        admin: i18n.t('engagement_insights.insights_banner.admin.surveys_not_active'),
        btnText: i18n.t('engagement_insights.insights_banner.admin.launch_button.all_surveys'),
        selectedSurvey: SelectedSurvey.Both,
      }
    }

    if (climate?.isFinished) {
      return {
        manager: i18n.t('engagement_insights.insights_banner.manager.climate_not_active'),
        admin: i18n.t('engagement_insights.insights_banner.admin.climate_not_active'),
        btnText: i18n.t('engagement_insights.insights_banner.admin.launch_button.climate_survey'),
        selectedSurvey: SelectedSurvey.Climate,
      }
    }

    if (enps?.isFinished) {
      return {
        manager: i18n.t('engagement_insights.insights_banner.manager.enps_not_active'),
        admin: i18n.t('engagement_insights.insights_banner.admin.enps_not_active'),
        btnText: i18n.t('engagement_insights.insights_banner.admin.launch_button.enps_survey'),
        selectedSurvey: SelectedSurvey.Enps,
      }
    }
  }

  const getScheduledMessage = () => {
    const climateDate = moment(climate?.attributes.start_on).format('MMM D')
    const enpsDate = moment(enps?.attributes.start_on).format('MMM D')

    if (enps?.isScheduled && climate?.isScheduled) {
      return i18n.t(`engagement_insights.insights_banner.admin.scheduled_surveys.both_surveys`, {
        enps_date: enpsDate,
        climate_date: climateDate,
      })
    }
    if (enps?.isScheduled) {
      return i18n.t(`engagement_insights.insights_banner.admin.scheduled_surveys.enps_survey`, {
        enps_date: enpsDate,
      })
    }
    if (climate?.isScheduled) {
      return i18n.t(`engagement_insights.insights_banner.admin.scheduled_surveys.climate_survey`, {
        climate_date: climateDate,
      })
    }
  }

  const { manager, admin, btnText, selectedSurvey } = getBannerData() || {}
  const scheduledMessage = getScheduledMessage()
  const message = !!btnText ? (canLaunchSurveysValue ? admin : manager) : scheduledMessage
  const showLaunchBtn = canLaunchSurveysValue && !!btnText
  const bannerColor = !!btnText ? 'champagne400' : 'grey400'

  const launchSurveys = () => {
    setSurveyToBeLaunched(selectedSurvey)
    navigate(navigation.engagement.insights.launch.fullPath())
  }

  return (
    <Box
      gap="s8"
      flexDirection="row"
      paddingY={showLaunchBtn ? 's8' : 's12'}
      alignItems="center"
      justifyContent="center"
      background={bannerColor}
    >
      <Icon.Medium color="grey800" icon="info-circle-line" />
      <Text.Normal size="300" color="grey1000">
        {message}
      </Text.Normal>
      {showLaunchBtn && <Button onClick={() => launchSurveys()}>{btnText}</Button>}
    </Box>
  )
}
export default observer(InsightsBanner)
